
export const migrationV3toV4 = `
# Migrating iTwin.js v3 project to iTwin.js v4

When migrating your iTwin.js v3 project to iTwin.js v4, it's important to be aware of the changes that might impact your project.
The release of iTwin.js v4 maintains backwards compatibility with the previous version, but there are some important updates to consider.

## Migration process

If you encounter compile or runtime errors after the Sandbox update, please refer to the following documentation for further guidance:

1. iTwin.js Core packages. [iTwin.js v4 Change Notes](https://www.itwinjs.org/changehistory/4.0.0/) contains information about new features and changes in iTwin.js core packages
2. @itwin/appui packages. If project uses \`@itwin/appui\` packages, consult [iTwinUI Migration Strategy](https://github.com/iTwin/appui/blob/master/docs/changehistory/4.0.0.md)
3. @itwin/itwinui-react package. if project uses \`@itwin/itwinui-react\` package, review [iTwinUI react v2 migration guide](https://github.com/iTwin/iTwinUI/wiki/iTwinUI-react-v2-migration-guide) for specific migration instructions

## Sandbox bootstrap update

The internal package \`@bentley/sandbox\` specific for sandboxes is deprecated and has beed removed. It was previously used to bootstrap the main \`App\` component defined in the entry file.
Here are some changes to note:

1. Refer to [Basic Viewport Template](https://www.itwinjs.org/sandboxes/iTwinPlatform/Basic%20Viewport%20Template) as an example of current approach.
2. You may need to add several helper files (via Sandbox settings dialog) to the project: \`Authorization Client\`, \`View Setup\`, \`Map Layer Options\`. Make sure you have latest version of these helper files selected
3. \`iTwinId\` and \`iModelId\` values are now provided through environment variables respectively: \`process.env.IMJS_ITWIN_ID\` and \`process.env.IMJS_IMODEL_ID\`
4. Authentication is done using a class exported from \`Authorization Client\` helper file.
`;

export const migrationV2toV4 = `
# Migrating iTwin.js v2 project to iTwin.js v4

There were major changes in iTwin.js v3 release, however upgrade from v3 to v4 is mostly backwards compatible.
It is recommended to review Change Notes of both v3 and v4 version and modify the project accordingly.

## Migration process

1. [iTwin.js v3 Change Notes](https://www.itwinjs.org/changehistory/3.0.0/#update-guide)
2. [iTwin.js v4 Change Notes](https://www.itwinjs.org/changehistory/4.0.0/) contains information about features and changes in iTwin.js core packages
3. @itwin/appui packages. If project uses \`@itwin/appui\` packages, consult [iTwinUI Migration Strategy](https://github.com/iTwin/appui/blob/master/docs/changehistory/4.0.0.md)
4. @itwin/itwinui-react package. if project uses \`@itwin/itwinui-react\` package, please review [iTwinUI react v2 migration guide](https://github.com/iTwin/iTwinUI/wiki/iTwinUI-react-v2-migration-guide)

## Sandbox bootstrap update

The internal package \`@bentley/sandbox\` specific for sandboxes is deprecated and has beed removed. It was previously used to bootstrap the main \`App\` component defined in the entry file.
Here are some changes to note:

1. Refer to [Basic Viewport Template](https://www.itwinjs.org/sandboxes/iTwinPlatform/Basic%20Viewport%20Template) as an example of current approach.
2. You may need to add several helper files (via Sandbox settings dialog) to the project: \`Authorization Client\`, \`View Setup\`, \`Map Layer Options\`. Make sure you have latest version of these helper files selected
3. \`iTwinId\` and \`iModelId\` values are now provided through environment variables respectively: \`process.env.IMJS_ITWIN_ID\` and \`process.env.IMJS_IMODEL_ID\`
4. Authentication is done using a class exported from \`Authorization Client\` helper file.
`;